import { render, staticRenderFns } from "./deviceArea.vue?vue&type=template&id=5f72060e&scoped=true&"
import script from "./deviceArea.vue?vue&type=script&lang=js&"
export * from "./deviceArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72060e",
  null
  
)

export default component.exports